export const API_SERVER = "https://fr.chinahouse.su/bot";
